import { render } from "./Region.vue?vue&type=template&id=5b51d356&scoped=true&ts=true"
import script from "./Region.vue?vue&type=script&lang=ts"
export * from "./Region.vue?vue&type=script&lang=ts"

import "./Region.vue?vue&type=style&index=0&id=5b51d356&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b51d356"]])

export default __exports__